import { render, staticRenderFns } from "./CommodityItem.vue?vue&type=template&id=7b2cf70b&scoped=true&"
import script from "./CommodityItem.vue?vue&type=script&lang=js&"
export * from "./CommodityItem.vue?vue&type=script&lang=js&"
import style0 from "./CommodityItem.vue?vue&type=style&index=0&id=7b2cf70b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2cf70b",
  null
  
)

export default component.exports